import { render, staticRenderFns } from "./fixedPhrase.vue?vue&type=template&id=13225221&"
import script from "./fixedPhrase.vue?vue&type=script&lang=js&"
export * from "./fixedPhrase.vue?vue&type=script&lang=js&"
import style0 from "./fixedPhrase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports